import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Box, TextField, Typography} from '@mui/material';
import {useFormInput} from '../../utils/utilities';
import moment from 'moment';
import CustomButton from '../CustomButton';
import {addPayment} from '../../actions';

const PaymentModal = () => {
  const dispatch = useDispatch();
  const {customerId} = useSelector(s => s.modal.modalProps);
  const {customerById} = useSelector(s => s.customers);
  const startsFrom = useFormInput(
    moment().subtract(1, 'M').format('yyyy-MM-DD'),
  );
  const numberOfMonths = useFormInput('1');
  const note = useFormInput('');

  const contract = customerById?.contract || 1;

  const onSubmit = e => {
    e.preventDefault();
    const months = [];
    let counter = 0;
    while (counter < numberOfMonths.value) {
      const fromDate = moment(
        moment(startsFrom.value).add(counter, 'M').startOf('day'),
      ).valueOf();
      const toDate = moment(
        moment(moment(startsFrom.value).add(counter + 1, 'M'))
          .subtract(1, 'day')
          .endOf('day'),
      ).valueOf();
      months.push({paid: +contract, fromDate, toDate});
      counter++;
    }
    dispatch(
      addPayment(
        customerId,
        note.value,
        months[0].fromDate,
        months[months.length - 1].toDate,
        months,
      ),
    );
  };

  return (
    <>
      <Typography alignSelf="center" variant="h6" mt="1rem" fontWeight="bold">
        Add new payment
      </Typography>
      <form onSubmit={onSubmit}>
        <Box
          display="flex"
          flexDirection="column"
          mt="2rem"
          gap="1rem"
          sx={{
            width: {xs: 'calc(100vw - 4rem)', sm: '30rem'},
          }}>
          <TextField
            value={contract}
            label="Price per month (€)"
            disabled
            inputProps={{min: 0}}
          />
          <TextField
            type={'date'}
            {...startsFrom}
            required
            label="Starts from"
          />
          <TextField
            type={'number'}
            {...numberOfMonths}
            required
            label="Number of months"
            inputProps={{min: 1}}
          />
          <TextField
            disabled
            value={numberOfMonths.value * contract}
            label="Total sum (€)"
            inputProps={{min: 1}}
          />
          <TextField {...note} multiline label="Note" minRows="3" />
          <CustomButton type="submit">Submit</CustomButton>
        </Box>
      </form>
    </>
  );
};

export default PaymentModal;
